<template>
  <nav class="navbar navbar-expand-lg bg-light">
    <div class="container-fluid">
      <button class="navbar-toggler" type="button" data-bs-toggle="collapse" data-bs-target="#navbarSupportedContent"
        aria-controls="navbarSupportedContent" aria-expanded="false" aria-label="Toggle navigation">
        <span class="navbar-toggler-icon"></span>
      </button>
      <div class="collapse navbar-collapse" id="navbarSupportedContent">
        <router-link to="/Admin/Home"><img src="./../../assets/logo_wbg.png" width="83" height="30" alt="logoDyC" />
        </router-link>
        <ul class="navbar-nav me-auto mb-2 mb-lg-0">
          <li class="nav-item dropdown">
            <a class="nav-link dropdown-toggle" href="#" role="button" data-bs-toggle="dropdown">
              Láminas
            </a>
            <ul class="dropdown-menu">
              <li>
                <router-link class="dropdown-item" to="/Admin/SheetCatalogue">Catálogo</router-link>
              </li>
              <li>
                <router-link class="dropdown-item" to="/Admin/SheetImages">Formas</router-link>
              </li>
            </ul>
          </li>
          <li class="nav-item dropdown">
            <a class="nav-link dropdown-toggle" href="#" role="button" data-bs-toggle="dropdown">
              Perfiles
            </a>
            <ul class="dropdown-menu">
              <li>
                <router-link class="dropdown-item" to="/Admin/ProfileCatalogue">Catálogo</router-link>
              </li>
              <li>
                <router-link class="dropdown-item" to="/Admin/ProfileImages">Formas</router-link>
              </li>
            </ul>
          </li>
          <li class="nav-item dropdown">
            <a class="nav-link dropdown-toggle" href="#" role="button" data-bs-toggle="dropdown">
              Tubos
            </a>
            <ul class="dropdown-menu">
              <li>
                <router-link class="dropdown-item" to="/Admin/TubeCatalogue">Catálogo</router-link>
              </li>
              <li>
                <router-link class="dropdown-item" to="/Admin/TubeImages">Formas</router-link>
              </li>
            </ul>
          </li>
          <li class="nav-item mt-2">
            <router-link class="link link1" to="/Admin/ListPrices"> Listado de precios |</router-link>
          </li>
          <li class="nav-item mt-2 ms-1">
            <router-link class="link link1" to="/Admin/ListImgFormFamilies">Grupos de formas | </router-link>
          </li>
          <li class="nav-item mt-2 ms-1">
            <router-link class="link link1" to="/Admin/ListRMts&Vars"> Catálogo M.P & Variables G. |</router-link>
          </li>
          <li class="nav-item mt-2 ms-1">
            <router-link class="link link1" to="/Admin/ListCompSections"> Tramos completos |</router-link>
          </li>
          <li class="nav-item">
            <a class="nav-link" href="#">Historial de Ordenes |</a>
          </li>
          <li class="nav-item">
            <a class="nav-link" @click.prevent="logOut">Cerrar Sesión</a>
          </li>
        </ul>
      </div>
    </div>
  </nav>
</template>
<script>
export default {
  data() {
    return {};
  },
  methods: {
    logOut() {
      localStorage.removeItem("token");
      this.$router.push("/");
      //console.log(localStorage.getItem("token"))
    },
  },
};
</script>
<style scoped>
.link1 {
  color: gray;
}
</style>